<app-navigation class="no-print"></app-navigation>
<!--<app-toast aria-live="polite" aria-atomic="true"></app-toast>-->
<div class="container-fluid" style="padding-right: 0; padding-left: 0;">
  <app-toast aria-live="polite" aria-atomic="true"></app-toast>
  <div style="display: flex; flex-direction: row; max-width:100vw; flex: 1;" id="loadingOverlay"
       [class.loading-overlay]="loading">
    <div *ngIf="loading; else content;" class="fa fa-pulse fa-spinner fa-4x"></div>

    <ng-template #content>
      <app-side-nav *ngIf="userConfig.config | async" style="background-color: #e3eaf3; width: 200px;"
                    class="no-print"></app-side-nav>
      <div style="flex: 1; min-width: 0;">
        <app-search *ngIf="showSearch" class="no-print"></app-search>
        <router-outlet></router-outlet>
      </div>
    </ng-template>
  </div>

</div>

